"use client";

import { createContext, useContext } from "react";

type StaffAccess = { userId: string; allowed: boolean } | null;
// Presentation only: data APIs and database views still authorize each caller.
export const StaffAccessContext = createContext<StaffAccess>(null);
export function useStaffNavigationAccess(userId: string | undefined) {
  const access = useContext(StaffAccessContext);
  return !!userId && access?.userId === userId && access.allowed;
}
